import { z } from "zod";

export interface Resource {
  ativo: boolean;
  funcionalidade: number;
  rotina: number;
  id?: string;
}

export const schema = z.object({
  ativo: z.boolean(),
  funcionalidade: z.number(),
  rotina: z.number(),
});

export type FormValues = z.infer<typeof schema>;

export function resourceToFormValues({
  ativo,
  ...values
}: Resource): FormValues {
  return {
    ...values,
    ativo: ativo === true,
  };
}

export function formValuesToResource({
  ativo,
  ...values
}: FormValues): Resource {
  //@ts-ignore
  return {
    ...values,
    ativo: ativo ? true : false,
  };
}
